import apiFetch from '../apiFetch'

export default function (values, token) {
  return apiFetch({endPoint: `EmpresaCentro/addCentro`, method: 'POST', body: values, token: token})
}